<template>
    <div style="height: 100%">
        <vs-chip v-if="params.value > 3" style="height: 60%; top:20%" :color="priorityToColor(params.value)">{{params.value}}</vs-chip>
        <p v-else>{{params.value}}</p>
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
        methods:{
            priorityToColor(priority) {
                switch (Number(priority)){
                    case 1:
                    case 2:
                    case 3:
                        return 'success';
                    case 4:
                        return 'warning';
                    case 5:
                        return 'danger';
                    default:
                        return 'dark';
                }
            }
        }
    });

</script>
